import { useState, useRef } from "react";

const MagnifyingImage = ({ src, magnifySize = 200, initialZoom = 2 }) => {
  const [mousePosition, setMousePosition] = useState({ visible: false, x: 0, y: 0, bgX: 0, bgY: 0 });
  const [zoom, setZoom] = useState(initialZoom); // Add zoom state
  const imgRef = useRef(null);

  const handleMouseMove = (e) => {
    const img = imgRef.current;
    if (!img) return;

    const { left, top, width, height } = img.getBoundingClientRect();

    const x = e.clientX - left;
    const y = e.clientY - top;

    if (x < 0 || y < 0 || x > width || y > height) {
      setMousePosition((prev) => ({ ...prev, visible: false }));
      return;
    }

    // Calculate zoomed background position
    const bgX = -(x * zoom - magnifySize / 2);
    const bgY = -(y * zoom - magnifySize / 2);

    setMousePosition({ visible: true, x, y, bgX, bgY, imgWidth: width, imgHeight: height });
  };

  const handleMouseLeave = () => {
    setMousePosition((prev) => ({ ...prev, visible: false }));
  };

  const handleWheel = (e) => {
    e.preventDefault(); // Prevent page scrolling
    const delta = e.deltaY; // Get scroll direction
    const zoomStep = 0.3; // Adjust zoom step size

    // Update zoom level based on scroll direction
    setZoom((prevZoom) => {
      const newZoom = delta < 0 ? prevZoom + zoomStep : prevZoom - zoomStep;
      return Math.max(1, newZoom); // Ensure zoom doesn't go below 1
    });
  };

  return (
    <div className="relative">
      {/* Main Image */}
      <img
        ref={imgRef}
        src={src}
        alt="Magnifiable"
        className="w-full h-full block border border-gray-700"
        onMouseMove={handleMouseMove}
        onMouseLeave={handleMouseLeave}
        onWheel={handleWheel} // Add wheel event listener
      />

      {/* Magnifying Glass */}
      {mousePosition.visible && (
        <div
          className="absolute pointer-events-none rounded border border-gray-700 shadow-lg overflow-hidden"
          style={{
            width: magnifySize,
            height: magnifySize,
            left: `${mousePosition.x - magnifySize / 2}px`,
            top: `${mousePosition.y - magnifySize / 2}px`,
            background: `
            url(${src}) no-repeat ${mousePosition.bgX}px ${mousePosition.bgY}px / ${mousePosition.imgWidth * zoom}px ${mousePosition.imgHeight * zoom}px,
            #202124
            `,
          }}
        />
      )}
    </div>
  );
};

export default MagnifyingImage;